module.exports = __webpack_public_path__ + "img/14 amigos.1551b005.jpg";